// extracted by mini-css-extract-plugin
module.exports = {"base":"foldable_base__1MWaw","title":"foldable_title__23jrV","isOpen":"foldable_isOpen__1bEOB","filter":"foldable_filter__11fFN","dropdown":"foldable_dropdown__2YSg2"};